import { styled } from "goober";
import { Box } from "../../Box";
import { Input } from "../../Input";
import { Text } from "../../Text";

export function SubLabel({ children }: { children: string }) {
  return (
    <Box horizontal={8}>
      <Text variant="text-small-md" color="var(--text-secondary)">
        {children}
      </Text>
    </Box>
  );
}

export function DomainField({
  value,
  onChange,
  isNew,
}: {
  value: string;
  onChange: (value: string) => void;
  isNew: boolean;
}) {
  return (
    <Field>
      <Box horizontal={8} vertical={10}>
        <Text variant="text-small-md">Domain</Text>
      </Box>
      <Input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={isNew ? "yourcompany.com" : undefined}
        required
        style={{ width: "100%" }}
      />
      {isNew && (
        <Box horizontal={8} top={6}>
          <Text variant="text-small" color="var(--text-secondary)">
            Users with this email domain will sign in via SSO
          </Text>
        </Box>
      )}
    </Field>
  );
}

export const Section = styled("div")`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const Field = styled("div")`
  display: flex;
  flex-direction: column;
`;

export const FormActions = styled("div")`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  padding-top: 8px;
`;

export const Divider = styled("div")`
  height: 0.5px;
  background: var(--border-alpha);
`;

export const MonoTextarea = styled("textarea")`
  width: 100%;
  padding: 8px 12px;
  background-color: var(--surface-primary);
  color: var(--text-primary);
  border: 0;
  outline: 0.5px solid var(--border-alpha);
  border-radius: 8px;
  font-family: var(--font-mono);
  font-weight: 350;
  font-size: 11px;
  line-height: 20px;
  resize: none;
  transition: box-shadow 100ms ease-out;
  &::placeholder {
    opacity: 0.3;
  }
  &:focus {
    outline: 0.5px solid var(--control-bg);
    box-shadow: 0 0 0 3px var(--border-alpha);
    &::placeholder {
      opacity: 0.6;
    }
  }
`;

export const CertTextarea = styled(MonoTextarea)`
  min-height: 80px;
`;
